import { CheckBoxProps } from "./types"
import React from "react"
import { Platform } from "~/ui/primitives"
import { useTheme } from '~/ui/styled'
import Icon from "~widgets/icon"
import styled from '~/ui/styled'
import { CenterFlex } from "~components/El"

const CheckBoxWrapper = styled(CenterFlex)`
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: auto;
`

const CheckBoxLabel = styled.Text`
  margin-left: 5px;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.secondaryText};
  line-height: 20px;
`

const CheckBox: React.FC<CheckBoxProps> = ({ curValue, value, label, onClick }) => {
  const theme = useTheme()
  const checked = Array.isArray(curValue) ? curValue.includes(value) : curValue === value
  return (
    <CheckBoxWrapper onClick={() => onClick?.(value)}>
      {checked ? (
        <Icon name="cg" color={theme.colors.primary} size={14} />
      ) : (
        <Icon name="yuan" color={theme.colors.border} size={14} />
      )}
      {!!label && <CheckBoxLabel>{label}</CheckBoxLabel>}
    </CheckBoxWrapper>
  )
}

export default CheckBox
